// extracted by mini-css-extract-plugin
module.exports = {"main":"Modal_main__J_B_W","header":"Modal_header__iLDRm"};